export default __webpack_public_path__ + "static/media/Category_OutdoorRecreation_135x195.31006191.jpg";